(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  new MutationObserver(function () {
    if (document.body.classList.contains('rebuy-cart-visible') && window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.hide();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  } catch(e) { console.error(e); }
})();
})();
